import { render } from "./ClientFormModal.vue?vue&type=template&id=1b12b42c&scoped=true"
import script from "./ClientFormModal.vue?vue&type=script&lang=js"
export * from "./ClientFormModal.vue?vue&type=script&lang=js"

import "./ClientFormModal.vue?vue&type=style&index=0&id=1b12b42c&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b12b42c"]])

export default __exports__